export default __webpack_public_path__ + "static/media/hiVis.5b8b20c8.jpg";